export function isNotificationPortfolioId(productId: number): boolean {
  return Number.isInteger(productId) && productId > 0 && productId <= 2_147_483_647;
}

export function notificationProductKey(product: { productType: string; productId: number }): string {
  return `${product.productType}:${product.productId}`;
}
